import React from 'react';
import {
  Dropdown,
  Option,
  shorthands,
  tokens,
  makeStyles,
  mergeClasses,
  DropdownProps,
} from '@fluentui/react-components';

const useStyles = makeStyles({
  zoomDropDown: {
    minWidth: '80px',
    ...shorthands.margin(tokens.spacingVerticalXXL, tokens.spacingHorizontalNone),
  },
});

export interface ZoomControlProps {
  zoomValue: string;
  onZoomSelect: DropdownProps['onOptionSelect'];
  i18n: {
    getString: (key: string) => string;
  };
}

const zoomOptions = [
  _TL_('75%'),
  _TL_('80%'),
  _TL_('90%'),
  _TL_('100%'),
  _TL_('110%'),
  _TL_('120%'),
  _TL_('125%'),
  _TL_('150%'),
  _TL_('200%'),
];

export const ZoomControl = ({ zoomValue, onZoomSelect, i18n }: ZoomControlProps) => {
  const classes = useStyles();

  return (
    <Dropdown
      value={zoomValue}
      selectedOptions={[zoomValue]}
      onOptionSelect={onZoomSelect}
      className={mergeClasses('zoom-control', classes.zoomDropDown)}
      appearance="filled-darker"
      aria-label={i18n.getString(_TL_('zoom'))}
    >
      {zoomOptions.map(option => (
        <Option key={option} value={option} >
          {i18n.getString(option)}
        </Option>
        ))}
    </Dropdown>);
};
